var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMinusNormal = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 2,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#767571",
  d: "M13.023 2H.977a.97.97 0 0 1-.69-.293A1 1 0 0 1 0 1C0 .735.103.48.286.293A.97.97 0 0 1 .977 0h12.046c.26 0 .508.105.69.293a1.012 1.012 0 0 1 0 1.414.97.97 0 0 1-.69.293"
})));
export default SvgMinusNormal;